import find from 'lodash/find';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FileFormatService {
  private types = {
    // # Microsoft Office
    // Allowed File types
    'application/pdf': 'pdf',
    'application/msword': 'doc',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'image/jpg': 'jpg',
    'image/jpeg': 'jpeg',
    'image/png': 'png',
    'image/svg+xml': 'svg',
    'audio/aac': 'aac',
    'audio/mp4': 'aac',
    'video/mp4': 'mp4',
    'audio/amr': 'amr',
    'audio/mpeg': 'mp3',
    'audio/ogg': 'ogg',
    'audio/opus': 'opus',
    'audio/vnd.dlna.adts': 'aac',

    // # Data interchange
    'application/atom+xml': 'atom',
    'application/json': 'json',
    'application/rss+xml': 'rss',
    'application/xml': 'xml',

    // # JavaScript
    'application/javascript': 'js',

    // # Media files
    'audio/midi': 'midi',
    'audio/x-realaudio': 'ra',
    'audio/x-wav': 'wav',
    'image/bmp': 'bmp',
    'image/gif': 'gif',
    'image/tiff': 'tif',
    'image/vnd.wap.wbmp': 'wbmp',
    'image/x-icon': 'ico',
    'image/webp': 'webp',
    'image/x-jng': 'jng',
    'video/3gpp': '3gp',
    'video/mpeg': 'mpg',
    'video/ogg': 'ogv',
    'video/quicktime': 'mov',
    'video/webm': 'webm',
    'video/x-flv': 'flv',
    'video/x-mng': 'mng',
    'video/x-ms-asf': 'asf',
    'video/x-ms-wmv': 'wmv',
    'video/x-msvideo': 'avi',
    'model/vnd.usdz+zip': 'usdz',

    // # Web fonts
    'application/font-woff': 'woff',
    'application/font-woff2': 'woff2',
    'application/vnd.ms-fontobject': 'eot',
    'application/x-font-ttf': 'ttf',
    'font/opentype': 'otf',

    // # Other
    'application/java-archive': 'jar',
    'application/mac-binhex40': 'hqx',
    'application/octet-stream': 'exe',
    'application/postscript': 'eps',
    'application/rtf': 'rtf',
    'application/vnd.google-earth.kml+xml': 'kml',
    'application/vnd.google-earth.kmz': 'kmz',
    'application/vnd.wap.wmlc': 'wmlc',
    'application/x-7z-compressed': '7z',
    'application/x-bb-appworld': 'bbaw',
    'application/x-chrome-extension': 'crx',
    'application/x-cocoa': 'cco',
    'application/x-java-jnlp-file': 'jnlp',
    'application/x-makeself': 'run',
    'application/x-opera-extension': 'oex',
    'application/x-perl': 'pl',
    'application/x-pilot': 'pdb',
    'application/x-rar-compressed': 'rar',
    'application/x-redhat-package-manager': 'rpm',
    'application/x-sea': 'sea',
    'application/x-shockwave-flash': 'swf',
    'application/x-stuffit': 'sit',
    'application/x-tcl': 'tcl',
    'application/x-x509-ca-cert': 'crt',
    'application/x-xpinstall': 'xpi',
    'application/xhtml+xml': 'xhtml',
    'application/xslt+xml': 'xsl',
    'application/zip': 'zip',
    'text/css': 'css',
    'text/html': 'html',
    'text/mathml': 'mml',
    'text/plain': 'txt',
    'text/vcard': 'vcf',
    'text/vnd.rim.location.xloc': 'xloc',
    'text/vnd.sun.j2me.app-descriptor': 'jad',
    'text/vnd.wap.wml': 'wml',
    'text/vtt': 'vtt',
    'text/x-component': 'htc',
  };
  private mimes = {
    // MIME types for Allowed File types
    aac: 'audio/aac',
    amr: 'audio/amr',
    usdz: 'model/vnd.usdz+zip',
    pdf: 'application/pdf',
    doc: 'application/msword',
    ppt: 'application/vnd.ms-powerpoint',
    xls: 'application/vnd.ms-excel',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    jpg: 'image/jpg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    svg: 'image/svg+xml',
    mp4: 'video/mp4',
    mp3: 'audio/mpeg',
    ogg: 'audio/ogg',
    opus: 'audio/opus',
  };

  private preview = ['image/bmp', 'image/gif', 'image/jpeg', 'image/png', 'image/svg+xml'];

  private checkType(mime: string) {
    return this.types[mime] || null;
  }

  private checkPreview(mime: string) {
    return !!find(this.preview, (o) => o === mime);
  }

  getType(mime: string) {
    return {
      type: this.checkType(mime),
      preview: this.checkPreview(mime),
    };
  }

  private checkMime(type: string) {
    return this.mimes[type] || '';
  }

  getMime(type: string) {
    return this.checkMime(type);
  }
}
